import React, { Component } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { object as YupObject, string as YupString, ref as YupRef } from 'yup';
import configMessages from '../../config/configMessages'
import { passwordRegex } from '../../utils/constants/constant';
export class ChangePasswordForm extends Component {
  initialValues = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  }
  validationSchema = YupObject({
    currentPassword: YupString()
      .required(`Current ${configMessages.password}`),
    newPassword: YupString()
      .required(`New ${configMessages.password}`)
      .matches(passwordRegex, 'password must contain One special characters, upper case and number.')
      .min(8, 'Atleast 8 Characters')
      .max(20, 'Only 20 Characters are allowed'),
    confirmPassword: YupString()
      .required(`Confirm ${configMessages.password}`)
      .oneOf([YupRef('newPassword'), null], 'Passwords must match')
  })

  getForm = (props, options = { isDisabled: false, btnLabel: 'Submit' }) => {
    let { status } = props;
    let { languageData } = this.props
    return (
      <Form className="form">
        <div className="form-group">
          <label>{languageData && languageData.currentPassword ? languageData.currentPassword : 'Current Password'}</label>
          <Field name="currentPassword" type='password' className="form-control"
          />
          <ErrorMessage name="currentPassword" component="label" className="error" />
        </div>
        <div className="form-group">
          <label>{languageData && languageData.newPassword ? languageData.newPassword : 'New Password'}</label>
          <Field name="newPassword" type='password' className="form-control"
          />
          <ErrorMessage name="newPassword" component="label" className="error" />
        </div>
        <div className="form-group">
          <label>{languageData && languageData.confirmPassword ? languageData.confirmPassword : 'Confirm Password'}</label>
          <Field name="confirmPassword" type='password' className="form-control"
          />
          <ErrorMessage name="confirmPassword" component="label" className="error" />
        </div>
        {
          status && (
            <div className="form-group text-center">
              <label className="error">{status}</label>
            </div>
          )
        }
        <div className="form-group text-center">
          <button className="btn btn-info btn-fill btn-wd" type="submit"
          >{languageData && languageData.changePassword ? languageData.changePassword : 'Change Password'}</button>
        </div>
      </Form>
    )
  }

  noop = () => { }

  render() {
    let { initialValues, onSubmit, formikRef = this.noop, options } = this.props;
    let defaultValues;
    if (!initialValues) {
      defaultValues = { ...this.initialValues }
    } else {
      defaultValues = {
        ...initialValues, currentPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
    return (
      <Formik
        initialValues={defaultValues}
        render={props => this.getForm(props, options)}
        onSubmit={onSubmit}
        validationSchema={this.validationSchema}
        ref={formikRef}
      />
    )
  }
}

// Lets do the mapping here going forward we'll split if required













